// Who is this, and what should the app open on.
//
// # WHY THIS IS DERIVED AND NOT A ROLE COLUMN
//
// There is no `role` on a user, deliberately: the same person coaches a squad on
// Tuesday and trains on Wednesday, and a flag would make them pick. What they
// see is derived from what they HAVE — a roster makes you a coach, an assignment
// makes you an athlete — so it follows them as their week changes and nobody
// administers it.
//
// # WHY A NEW USER IS TREATED AS AN ATHLETE
//
// This used to return COACH, and the reasoning was sound at the time: someone
// with neither a roster nor an assignment has nothing to train, and the athlete
// home would greet them with an empty screen and no way out of it.
//
// That reasoning predates the self-serve generator. The athlete home's empty
// state now leads with "Write me a program", so the screen has a door — and it
// is the right door for somebody who arrived with no coach and no squad, which
// is what having neither a roster nor an assignment usually means. Sending them
// to the coach home offered "create a program", a manual block builder, to the
// one person least equipped to use it.

export const AUDIENCE = {
  COACH: 'coach',
  ATHLETE: 'athlete',
};

/**
 * The audience for a signed-in user.
 *
 * @param {{athletes?: Array, assignments?: Array}} held what the user has
 * @returns {'coach'|'athlete'}
 */
export function audienceFrom(held) {
  const athletes = held?.athletes ?? [];
  const assignments = held?.assignments ?? [];

  // A roster wins. Someone who coaches AND trains still opens on the roster:
  // their own training is one nav click away, whereas a squad they have not
  // looked at is the thing that goes wrong unattended.
  if (athletes.length > 0) return AUDIENCE.COACH;
  if (assignments.length > 0) return AUDIENCE.ATHLETE;
  return AUDIENCE.ATHLETE;   // brand new: the generator is their first action
}

/**
 * Reads either response shape the API returns.
 *
 * The list endpoints answer `{athletes: [...]}` and `{assignments: [...]}`, but
 * an empty result has come back as a bare array before now. Treating a bare
 * array as "no items" would silently make every athlete look like a coach.
 */
export function listFrom(body, key) {
  if (Array.isArray(body)) return body;
  if (Array.isArray(body?.[key])) return body[key];
  return [];
}
